import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { debounce } from 'lodash'

import Filter from '../Filter/Filter'

const RecipientsFilter = ({
  name,
  placeholder,
  options,
  value,
  onChange,
  disabled,
  fetchRecipients,
}) => {
  const [prevSearchValue, setPrevSearchValue] = useState('')
  const [searchValue, setSearchValue] = useState('')
  const debouncedFetch = debounce(fetchRecipients, 800)

  useEffect(() => {
    if (prevSearchValue !== searchValue) {
      window.addEventListener('keydown', debouncedFetch(searchValue))
    }
    setPrevSearchValue(searchValue)
    return () => {
      window.removeEventListener('keydown', debouncedFetch)
    }
  }, [searchValue])

  return (
    <Filter
      name={name}
      placeholder={placeholder}
      buttonClass="survey-form__input"
      options={options}
      handleSearch={(val) => setSearchValue(val)}
      searchValue={searchValue}
      value={value}
      onChange={onChange}
      config={{
        multiple: true,
        hasSearch: true,
      }}
      disabled={disabled}
    />
  )
}

RecipientsFilter.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  options: PropTypes.array,
  value: PropTypes.array,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  fetchRecipients: PropTypes.func,
}

export default RecipientsFilter
